import './_styles.scss';
import React from 'react';

const TextInput = ({ name, value, placeholder, onChangeEvent }) => {

  const on_change_filter = (event) => {

    event.persist();

    return onChangeEvent(event.target.value);

  }

  return (
    <div className="text-input">

      <div className="placeholder">KES</div>

      <input
        name={name}
        type='number'
        placeholder={placeholder}
        onChange={on_change_filter}
        value={value > 0 ? value : ''}
      />

    </div>
  )
}

export default ({ pricing, onChangeEvent }) => {

  const [min_price,update_min_price] = React.useState(pricing.min);

  const [max_price,update_max_price] = React.useState(pricing.max);

  const on_change_filter = () => onChangeEvent('pricing',{
    min: min_price,
    max: max_price
  });

  return (
    <div className='filter-group price-filter'>

      <div className="Heading">Pricing</div>

      <TextInput
        value={min_price}
        name='min_price'
        placeholder='Min Price'
        onChangeEvent={update_min_price}
      />

      <TextInput
        value={max_price}
        name='max_price'
        placeholder='Max Price'
        onChangeEvent={update_max_price}
      />

      <div className="action-button" onClick={on_change_filter}>
        Search
      </div>

    </div>
  )
}
